import React from 'react';
import DebitNoteForm from './DebitNoteForm';
import { useParams } from 'react-router-dom';

const EditDebitNotePage = () => {
    const { id } = useParams();
    return id ? <DebitNoteForm formType="edit" currentId={id} /> : <div>Loading...</div>;
};
export default EditDebitNotePage;